import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'

import { FieldPhone } from '@/components/Form/FieldPhone'
import { Tag } from '@/components/UI/Tag'

import { RegisterPhoneModel } from '../../models/Register.model'
import './PhoneStep.scss'

interface IPhoneStepProps {
  className?: string
}

const cnPhoneStep = cn('PhoneStep')

export const PhoneStep: FC<IPhoneStepProps> = ({ className }) => {
  const { t } = useTranslation()

  const {
    control,
    formState: { errors },
  } = useFormContext<RegisterPhoneModel>()

  return (
    <div className={cnPhoneStep(null, [className])}>
      <Tag className={cnPhoneStep('title')}>{t('register-for-title')}</Tag>
      <div className={cnPhoneStep('text')}>{t('register-for-text')}</div>

      <Controller
        name='phone'
        control={control}
        render={({ field: { onChange, value } }) => (
          <FieldPhone
            onChange={onChange}
            value={value}
            errors={errors.phone?.message}
          />
        )}
      />
    </div>
  )
}
